import { render, staticRenderFns } from "./NewsletterManagement.vue?vue&type=template&id=4181b670&scoped=true"
import script from "./NewsletterManagement.vue?vue&type=script&lang=js"
export * from "./NewsletterManagement.vue?vue&type=script&lang=js"
import style0 from "./NewsletterManagement.vue?vue&type=style&index=0&id=4181b670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4181b670",
  null
  
)

export default component.exports